<script setup>
import { ref, defineAsyncComponent } from 'vue';
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';

// OCHAT: la carita que abre el selector de emojis, para reusarla en el texto del
// posteo y en cada variable de la plantilla de WhatsApp.

defineProps({
  // Hacia donde se despliega el panel. Arriba del campo cuando no hay lugar abajo.
  position: {
    type: String,
    default: 'bottom',
    validator: value => ['top', 'bottom'].includes(value),
  },
});

const emit = defineEmits(['select']);

// El selector se carga en diferido porque arrastra la tabla entera de emojis, que
// no tiene por qué pesar en la carga del compositor cuando casi nunca se abre.
// Mismo patrón que NewConversation/components/ActionButtons.vue.
const EmojiIconPicker = defineAsyncComponent(
  () =>
    import('dashboard/components-next/emoji-icon-picker/EmojiIconPicker.vue')
);

const { t } = useI18n();
const isOpen = ref(false);

// Se cierra al elegir: quien pone dos emojis seguidos vuelve a abrirlo, y dejarlo
// abierto tapa el campo que se está escribiendo.
const onSelect = event => {
  emit('select', event.value);
  isOpen.value = false;
};
</script>

<template>
  <div v-on-click-outside="() => (isOpen = false)" class="relative">
    <Button
      type="button"
      variant="ghost"
      color="slate"
      size="sm"
      icon="i-lucide-smile-plus"
      class="!w-8"
      :title="t('MARKETING.CAMPAIGN.FORM.EMOJI_PICKER')"
      @click="isOpen = !isOpen"
    />
    <EmojiIconPicker
      v-if="isOpen"
      mode="emoji"
      class="!w-[min(22rem,calc(100vw-2rem))]"
      :class="
        position === 'top'
          ? '!top-auto !bottom-full mb-1.5 ltr:right-0 rtl:left-0'
          : 'mt-1.5 ltr:right-0 rtl:left-0'
      "
      @select="onSelect"
    />
  </div>
</template>
